var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExpert = function SvgExpert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.969 12.482c1.365 0 2.53-.488 3.502-1.459.97-.97 1.459-2.142 1.459-3.502 0-1.365-.489-2.54-1.46-3.531-.97-.992-2.137-1.49-3.501-1.49-1.365 0-2.53.498-3.502 1.49-.97.99-1.46 2.172-1.46 3.531 0 1.365.49 2.531 1.46 3.502.971.971 2.142 1.46 3.502 1.46Zm6.57 2.715c-2.277-.916-4.468-1.374-6.57-1.374-2.103 0-4.29.458-6.572 1.374-.174.07-.339.14-.493.215l.688 1.63 4.717.402c.095.01.175.07.204.165.03.09 0 .19-.07.254l-3.58 3.104.537 2.316h14.546V18.8c.005-1.49-1.13-2.684-3.407-3.601v-.002Zm-15.01-1.19 1.505 3.547h-.001c.034.075.1.124.174.13l3.85.328-2.918 2.53a.213.213 0 0 0-.07.21l.877 3.766-3.308-1.998a.216.216 0 0 0-.219 0l-3.307 1.998.876-3.766a.217.217 0 0 0-.07-.21L0 18.013l3.85-.328a.216.216 0 0 0 .175-.13l1.505-3.547Z"
  })));
};

export default SvgExpert;